/**
 * Reusable header component for login steps
 * Displays title and description
 */
import React from "react"
import styles from "../styles/login.module.scss"

interface StepHeaderProps {
  title: string
  description: string
}

const StepHeader: React.FC<StepHeaderProps> = ({ title, description }) => {
  return (
    <>
      <div className={styles["login__title"]}>{title}</div>
      <div className={styles["login__description"]}>{description}</div>
    </>
  )
}

export default StepHeader

